import angular from 'angular';

export default angular.module('reset-account-password-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider
      .state('user-resetAccountPassword', {
        parent: 'arw',
        url: '/reset-account-password/{userId:[0-9]*}',
        template: '<reset-account-password></reset-account-password>',
        redirectTo: 'permissions-denied',
        params: {
          skipDirtyForms: false,
        },
      });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/auth/components/reset-account-password/reset-account-password-routing-module.js